import { MdPlayArrow, MdStop } from 'react-icons/md'

import './previewRunControls.css'
import { usePreviewControl } from './usePreviewControl'
import { volumeIcon } from './volumeIcon'

interface PreviewRunControlsProps {
  /**
   * プレビュー領域内へオーバーレイ配置するときに true。
   * コンテナをポインタ透過にし、視認用の影を付ける（ヘッダー用とは見た目が異なる）。
   */
  overlay?: boolean
}

/**
 * おためしプレイの再生/停止/音量操作。
 * 実体の制御は `usePreviewControl` 経由で PreviewModal 内の PreviewPanel に委譲する。
 * PreviewModal のプレビュー領域内左下にオーバーレイ配置して使う。
 */
export const PreviewRunControls = ({
  overlay = false,
}: PreviewRunControlsProps) => {
  const { start, stop, changeVolume, toggleMute, ready, running, volume } =
    usePreviewControl()
  const muted = volume <= 0

  return (
    <div
      className={`preview-run-controls${overlay ? ' preview-run-controls--overlay' : ''}`}
    >
      <button
        type="button"
        className="preview-run-control-button is-start"
        onClick={start}
        // 実行中は連続実行を防ぐため無効化。停止/初期化で再び押せるようになる。
        disabled={!ready || running}
        aria-label="じっこう"
        title="じっこう"
      >
        <MdPlayArrow size={22} aria-hidden="true" />
      </button>
      <button
        type="button"
        className="preview-run-control-button is-stop"
        onClick={stop}
        // 停止中（未実行含む）は連打しても意味がないため無効化。実行で再び押せる。
        disabled={!ready || !running}
        aria-label="ていし"
        title="ていし"
      >
        <MdStop size={20} aria-hidden="true" />
      </button>
      <button
        type="button"
        className="preview-run-control-button is-mute"
        onClick={toggleMute}
        // パネル未 ready では委譲先が未初期化のため無効化（再生/停止と同様）。
        disabled={!ready}
        aria-label={muted ? 'ミュートかいじょ' : 'ミュート'}
        aria-pressed={muted}
        title={muted ? 'ミュートかいじょ' : 'ミュート'}
      >
        {volumeIcon(volume)}
      </button>
      <input
        type="range"
        className="preview-volume-slider"
        min={0}
        max={1}
        step={0.01}
        value={volume}
        onInput={(event) => changeVolume(Number(event.currentTarget.value))}
        // パネル未 ready では委譲先が未初期化のため無効化。
        disabled={!ready}
        aria-label="おんりょう"
      />
    </div>
  )
}
